// Lib
import React from 'react';
import { useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';

// Components
import Feather from '../../../Feather';
import Button from '../../../Button';
import Spinner from '../../../Spinner';

// Hooks
import useAddressFormat from '../../../../pages/AddressBook/hooks/useAddressFormat';

// Styles
import { useStyles } from './ErrorAddressStyles';

const ErrorAddress = ({
  originalAddress,
  onBackToForm,
  editMode,
  enteredAddress,
}) => {
  const { classes, cx } = useStyles();
  const { onSave, apiError } = useAddressFormat(enteredAddress, editMode);
  const { isUspsLimitExceeded, uspsLimitExceededMessage } = useSelector(
    (state) => ({
      isUspsLimitExceeded:
        state.addressBook.addressBook.afterValidation.usps_limit_exceeded,
      uspsLimitExceededMessage:
        state.validate.configurableMessage.usps_request_limit_exceeded_message,
    }),
  );

  return (
    <div className={classes.root}>
      <div className={classes.error}>
        <Feather
          className={cx(classes.title, classes.titleIcon)}
          nativeColor
          type="error"></Feather>
        Error
      </div>
      <Typography variant="h2">
        {isUspsLimitExceeded
          ? uspsLimitExceededMessage
          : 'We Were Unable To Validate This Address.'}
      </Typography>
      {!isUspsLimitExceeded && (
        <div className={classes.infoText}>
          Go Back And Change The Address To Revalidate Or Save It As It Is.
        </div>
      )}
      <div className={classes.label}>Entered Address</div>
      <div className={classes.address}>{originalAddress}</div>
      {apiError && <p className={classes.accent}>{apiError}</p>}
      <div className={classes.buttons}>
        <Button onClick={onBackToForm}>Back</Button>
        <Button
          loadingIndicator={<Spinner size={20} height={24} />}
          variant="text"
          onClick={onSave}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default ErrorAddress;
